import { Box, styled } from '@mui/material';

export const ThumbnailWrapper = styled(Box)({
  position: 'relative',
});

export const ThumbnailImage = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected: boolean }>(({ theme, isSelected }) => ({
  minWidth: '120px',
  width: '120px',
  height: '120px',
  borderRadius: '1rem',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  flexShrink: 0,
  cursor: 'pointer',
  backgroundColor: theme.palette.grey[100],
  border: isSelected ? `4px solid ${theme.palette.accent.main}` : '2px solid transparent',
  transition: 'all 0.2s ease',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
}));
